export class ApiEndPointsRoles {

    // Summary
    // Call api to get user list
    roleList = 'api/ManageRole/GetRoleList';
     // Summary
    // Call api to add Role
    addRole = 'api/ManageRole/AddRole';

    deleteRole = 'api/ManageRole/DeleteRole'
    updateRole= 'api/ManageRole/UpdateRole'
}
